module.exports = __webpack_public_path__ + "img/compass.61a69421.svg";